import { useText } from "@/lib/content";
import { useState } from "react";
import { MessagesSquare, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { loadWidget, openChat } from "@/lib/widget";
import { Notice } from "@/components/form/FormFeedback";

export const AiChatCta = ({ goTab }) => {
    const t = useText();
    const [state, setState] = useState({ kind: null });

    const onClick = async () => {
        setState({ kind: "loading" });
        try {
            const { data } = await api.get("/companies/me/ai-widget");
            if (!data.consent) return setState({ kind: "no-consent" });
            if (!data.configured) return setState({ kind: "not-configured" });
            await loadWidget(data.embed_code);
            openChat();
            setState({ kind: "open" });
        } catch {
            setState({ kind: "failed" });
        }
        return undefined;
    };

    return (
        <section aria-labelledby="ai-cta-title" data-testid="ai-chat-cta-section">
            <div className="surface-dark rounded-xl p-5 sm:p-6 flex flex-wrap items-center gap-4 justify-between">
                <div className="flex items-start gap-3 min-w-0 flex-1">
                    <MessagesSquare aria-hidden="true" className="text-edi-lime shrink-0 mt-1" size={28} />
                    <div>
                        <h3 id="ai-cta-title" className="text-xl font-bold">{t("profilo.ai_title")}</h3>
                        <p className="text-edi-muted whitespace-pre-line">{t("profilo.ai_text")}</p>
                    </div>
                </div>
                <button type="button" className="btn-primary" onClick={onClick} disabled={state.kind === "loading"} data-testid="ai-chat-cta-button">
                    {state.kind === "loading" && <Loader2 aria-hidden="true" size={18} className="animate-spin" />}
                    {t("profilo.ai_cta")}
                </button>
            </div>
            <div aria-live="polite" className="mt-4 empty:mt-0" data-testid="ai-chat-cta-feedback">
                {state.kind === "loading" && <p role="status">Apertura dell'assistente AI in corso…</p>}
                {state.kind === "open" && <p role="status" data-testid="ai-chat-opened-message">Assistente AI aperto.</p>}
                {state.kind === "no-consent" && (
                    <Notice kind="warning" role="alert" testId="ai-chat-no-consent-warning">
                        <p className="whitespace-pre-line">{t("profilo.consent_warning")}</p>
                        <button type="button" className="mt-2 underline font-semibold text-edi-link" onClick={() => goTab("privacy")} data-testid="ai-chat-go-privacy-link">
                            Vai a Privacy e consensi
                        </button>
                    </Notice>
                )}
                {state.kind === "not-configured" && <Notice kind="info" testId="ai-chat-not-configured">{t("profilo.ai_unavailable")}</Notice>}
                {state.kind === "failed" && <Notice kind="error" role="alert" testId="ai-chat-load-error">Impossibile aprire l'assistente AI, riprova più tardi</Notice>}
            </div>
        </section>
    );
};
